import { useEffect, useState } from 'react'
import { X, AlertTriangle, Upload, Send, Lock } from 'lucide-react'
import api from '../api/client'
import SearchableSelect from './SearchableSelect'
import { successModal, errorModal } from './ui'

// Campos de cliente vs. contrato vs. documento (espelha o catálogo do admin)
const CLIENTE_FIELDS = { nome: 'Nome do Cliente', cpf_cnpj: 'CPF/CNPJ', telefone: 'Telefone', email: 'E-mail' }
const DOC_FIELDS = { conta_luz: 'Conta de Luz', doc_foto: 'Documento com Foto', documentos: 'Outros documentos' }
const inp = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400'

// Edição do MESMO cadastro pelo licenciado — SOMENTE os campos liberados pelo admin (doc Painel de Notificações).
export default function CorrecaoConexao({ contratoId, onClose, onDone }) {
  const [c, setC] = useState(null)
  const [cli, setCli] = useState({})
  const [ct, setCt] = useState({})            // campos do contrato
  const [docsSel, setDocsSel] = useState({})  // {tipo: File}
  const [dists, setDists] = useState([])
  const [gers, setGers] = useState([])
  const [ofs, setOfs] = useState([])
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState('')

  useEffect(() => {
    api.get(`/contratos-adesao/${contratoId}`).then((r) => {
      const d = r.data; setC(d)
      setCt({ distribuidora_id: d.distribuidora_id || '', geradora_id: d.geradora_id || '', oferta_id: d.oferta_id || '',
        numero_instalacao: d.numero_instalacao || '', tipo_instalacao: d.tipo_instalacao || '',
        media_consumo: d.media_consumo || '', valor_fatura: d.valor_fatura || '',
        endereco: (d.dados_customizados || {}).endereco || '' })
      if (d.cliente) setCli({ nome: d.cliente.nome || '', cpf_cnpj: d.cliente.cpf_cnpj || '', telefone: d.cliente.telefone || '', email: d.cliente.email || '' })
    }).catch(() => {})
    api.get('/distribuidoras?limit=200').then((r) => setDists(r.data.data || r.data || [])).catch(() => {})
    api.get('/geradoras?limit=200').then((r) => setGers(r.data.data || r.data || [])).catch(() => {})
    api.get('/ofertas/publico').then((r) => setOfs(r.data || [])).catch(() => {})
  }, [contratoId])

  if (!c) return null
  const liberados = c.campos_liberados || []
  const lib = (k) => liberados.includes(k)
  const anyLib = liberados.length > 0

  async function enviar() {
    setBusy(true); setMsg('')
    try {
      // 1) Cliente (campos liberados)
      const cliPatch = {}
      Object.keys(CLIENTE_FIELDS).forEach((k) => { if (lib(k)) cliPatch[k] = cli[k] })
      if (Object.keys(cliPatch).length && c.cliente_id) {
        try { await api.put(`/clientes/${c.cliente_id}`, cliPatch) } catch { /* segue */ }
      }
      // 2) Contrato (só colunas liberadas)
      const patch = {}
      if (lib('distribuidora')) patch.distribuidora_id = ct.distribuidora_id ? Number(ct.distribuidora_id) : null
      if (lib('gerador_parceiro')) patch.geradora_id = ct.geradora_id ? Number(ct.geradora_id) : null
      if (lib('produto')) patch.oferta_id = ct.oferta_id ? Number(ct.oferta_id) : null
      if (lib('uc')) patch.numero_instalacao = ct.numero_instalacao
      if (lib('tipo_instalacao')) patch.tipo_instalacao = ct.tipo_instalacao
      if (lib('media_consumo')) patch.media_consumo = ct.media_consumo ? Number(ct.media_consumo) : null
      if (lib('valor_fatura')) patch.valor_fatura = ct.valor_fatura ? Number(ct.valor_fatura) : null
      if (lib('endereco')) patch.dados_customizados = { ...(c.dados_customizados || {}), endereco: ct.endereco }
      if (Object.keys(patch).length) await api.put(`/contratos-adesao/${c.id}`, patch)
      // 3) Documentos
      for (const [tipo, file] of Object.entries(docsSel)) {
        if (!file) continue
        const fd = new FormData(); fd.append('tipo', tipo); fd.append('file', file)
        await api.post(`/contratos-adesao/${c.id}/documentos`, fd)
      }
      // 4) Reenviar para análise (mesmo cadastro, preserva histórico)
      await api.post(`/contratos-adesao/${c.id}/enviar`)
      await successModal('Correções enviadas! O cadastro voltou para a Fila de Análise.', { title: 'Enviado para análise' })
      onDone && onDone()
    } catch (e) { setMsg(e?.response?.data?.detail || 'Erro ao enviar correções') } finally { setBusy(false) }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="px-5 py-4 bg-gradient-to-r from-amber-50 to-orange-50 border-b border-amber-100 flex items-center gap-2">
          <AlertTriangle size={18} className="text-amber-600" />
          <div className="flex-1"><h3 className="font-heading font-bold text-gray-900">Corrigir cadastro #{c.id}</h3>
            <p className="text-[11px] text-gray-500">{c.cliente_nome || (c.cliente && c.cliente.nome) || ''}</p></div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700"><X size={20} /></button>
        </div>

        <div className="p-5 overflow-y-auto tc-scroll space-y-4">
          {c.motivo_correcao && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
              <p className="text-xs font-semibold text-amber-800">Solicitação do administrador</p>
              <p className="text-xs text-amber-700 mt-0.5 whitespace-pre-line">{c.motivo_correcao}</p>
            </div>
          )}
          {!anyLib && <p className="text-sm text-gray-500 bg-gray-50 rounded-lg px-3 py-2">O administrador não especificou campos — corrija conforme a solicitação acima e reenvie.</p>}

          {/* Campos do cliente */}
          {Object.entries(CLIENTE_FIELDS).map(([k, label]) => lib(k) && (
            <div key={k}>
              <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
              <input className={inp} value={cli[k] || ''} onChange={(e) => setCli({ ...cli, [k]: e.target.value })} />
            </div>
          ))}
          {lib('endereco') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Endereço</label>
              <input className={inp} value={ct.endereco} onChange={(e) => setCt({ ...ct, endereco: e.target.value })} /></div>
          )}
          {lib('distribuidora') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Distribuidora</label>
              <SearchableSelect value={ct.distribuidora_id} onChange={(v) => setCt({ ...ct, distribuidora_id: v })}
                options={dists.map((d) => ({ value: d.id, label: `${d.nome}${d.estado ? ' (' + d.estado + ')' : ''}` }))} placeholder="Selecionar..." /></div>
          )}
          {lib('gerador_parceiro') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Gerador Parceiro</label>
              <SearchableSelect value={ct.geradora_id} onChange={(v) => setCt({ ...ct, geradora_id: v })}
                options={gers.map((g) => ({ value: g.id, label: g.nome }))} placeholder="Selecionar..." /></div>
          )}
          {lib('produto') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Produto</label>
              <SearchableSelect value={ct.oferta_id} onChange={(v) => setCt({ ...ct, oferta_id: v })}
                options={ofs.map((o) => ({ value: o.id, label: o.nome }))} placeholder="Selecionar..." /></div>
          )}
          {lib('uc') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">UC (Nº Instalação)</label>
              <input className={inp} value={ct.numero_instalacao} onChange={(e) => setCt({ ...ct, numero_instalacao: e.target.value })} /></div>
          )}
          {lib('tipo_instalacao') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Tipo de Instalação</label>
              <input className={inp} value={ct.tipo_instalacao} onChange={(e) => setCt({ ...ct, tipo_instalacao: e.target.value })} /></div>
          )}
          {lib('media_consumo') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Média de Consumo (kWh)</label>
              <input type="number" className={inp} value={ct.media_consumo} onChange={(e) => setCt({ ...ct, media_consumo: e.target.value })} /></div>
          )}
          {lib('valor_fatura') && (
            <div><label className="block text-xs font-medium text-gray-600 mb-1">Valor da fatura (R$)</label>
              <input type="number" className={inp} value={ct.valor_fatura} onChange={(e) => setCt({ ...ct, valor_fatura: e.target.value })} /></div>
          )}
          {/* Documentos liberados */}
          {Object.entries(DOC_FIELDS).map(([k, label]) => lib(k) && (
            <label key={k} className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
              <Upload size={15} className="text-accent-500" />
              <span className="flex-1">{label} — {docsSel[k] ? docsSel[k].name : 'anexar novo (substitui o anterior)'}</span>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" onChange={(e) => setDocsSel({ ...docsSel, [k]: e.target.files?.[0] })} />
            </label>
          ))}

          <p className="text-[11px] text-gray-400 flex items-center gap-1"><Lock size={11} /> Apenas os campos liberados pelo administrador podem ser alterados. Nenhum novo cadastro é criado.</p>
          {msg && <p className="text-sm text-red-600 bg-red-50 rounded px-3 py-2">{msg}</p>}
        </div>

        <div className="px-5 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 rounded-xl border border-gray-200 text-gray-500 text-sm">Cancelar</button>
          <button onClick={enviar} disabled={busy} className="px-5 py-2 rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white text-sm font-bold shadow-md flex items-center gap-1.5 disabled:opacity-50">
            <Send size={15} /> {busy ? 'Enviando...' : 'Enviar para Análise'}
          </button>
        </div>
      </div>
    </div>
  )
}
